// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25Pm9","productName":"Table_productName__ISWo6"};